import React, { createContext, useEffect, useState } from "react";
export const ContextStore = createContext();

const StoreProvider = ({ children }) => {
    const [dataHistory, setDataHistory] = useState([]);

    const data = {
        data: ["Độ ẩm", "Nhiệt độ", "Ánh sáng"],
        unit: ["%", "℃", "x100lux"],
    };
    const [datas, setDatas] = useState(
        data.data.map((item) => [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        ])
    );

    console.log(datas);

    const [actions, setActions] = useState([]);
    const [newData, setNewData] = useState(data.data.map((item) => 0));
    const date = new Date();
    useEffect(() => {
        const intervalId = setInterval(() => {
            setNewData((prop) => {
                const result = [];
                const max = [100, 50, 200];
                prop.forEach((element, index) => {
                    result.push(Math.floor(Math.random() * max[index]));
                });
                setDataHistory((prop) => {
                    return [
                        {
                            id: prop.length + 1,
                            time: `${date}`,
                            values: {
                                "Độ ẩm": result[0],
                                "Nhiệt độ": result[1],
                                "Ánh sáng": result[2],
                            },
                        },
                        ...prop,
                    ];
                });
                return [...result];
            });
        }, 2000);
        return () => {
            clearInterval(intervalId);
            console.log("aaa");
        };
    }, []);
    useEffect(() => {
        setDatas((prop) => {
            const tmp = [...prop];
            const result = [];
            tmp.forEach((element, index) => {
                let arr = [...element];
                arr.pop();
                arr = [newData[index], ...arr];
                result.push(arr);
            });
            return [...result];
        });
    }, [newData]);

    return (
        <ContextStore.Provider
            value={{
                data,
                actions,
                setActions,
                newData,
                setNewData,
                datas,
                setDatas,
                dataHistory,
            }}
        >
            {children}
        </ContextStore.Provider>
    );
};

export default StoreProvider;
